import { createMiddlewareFromEventsMap } from '@noths/polaris-client-next-redux';

import { GAEventsMap as deliveryBlockGAEventsMap } from 'src/components/molecules/DeliveryBlock';
import { GAEventsMap as deliveryByEventGAEventsMap } from 'src/components/molecules/DeliveryEvent/tracking';
import { GAEventsMap as crossSellModalGAEventsMap } from 'src/components/organisms/CrossSellModal/tracking/eventsMap';
import { GAEventsMap as deliveryAreaGAEventsMap } from 'src/components/organisms/DeliveryArea';
import { GAEventsMap as favouritesGAEventsMap } from 'src/components/organisms/Favourites';
import { GAEventsMap as linkCarouselGAEventsMap } from 'src/components/organisms/LinkCarousel';
import { GAEventsMap as partnerStorefrontGAEventsMap } from 'src/components/organisms/PartnerStorefront';
import { GAEventsMap as productDescriptionGAEventsMap } from 'src/components/organisms/ProductDescription';
import { GAEventsMap as productImagesCarouselGAEventsMap } from 'src/components/organisms/ProductImagesCarousel';
import { GAEventsMap as productInfoGAEventsMap } from 'src/components/organisms/ProductInfo';
import { GAEventsMap as productReviewsGAEventsMap } from 'src/components/organisms/ProductReviews';
import { GAEventsMap as recommendedProductsShelfGAEventsMap } from 'src/components/organisms/RecommendedProductsShelf';
import { GAEventsMap as basketGAEventsMap } from './basket';
import { ReduxApplicationState } from './combinedReducer';
import { GAEventsMap as deliveryZoneOptionsGAEventsMap } from './deliveryZoneOptions';
import { GAEventsMap as personalisationGAEventsMap } from './personalisation';

export const eventsMap = {
  ...basketGAEventsMap,
  ...crossSellModalGAEventsMap,
  ...deliveryAreaGAEventsMap,
  ...deliveryBlockGAEventsMap,
  ...deliveryByEventGAEventsMap,
  ...deliveryZoneOptionsGAEventsMap,
  ...favouritesGAEventsMap,
  ...linkCarouselGAEventsMap,
  ...partnerStorefrontGAEventsMap,
  ...personalisationGAEventsMap,
  ...personalisationGAEventsMap,
  ...productDescriptionGAEventsMap,
  ...productImagesCarouselGAEventsMap,
  ...productInfoGAEventsMap,
  ...productReviewsGAEventsMap,
  ...recommendedProductsShelfGAEventsMap,
};

export const GAMiddleware = createMiddlewareFromEventsMap<ReduxApplicationState>(eventsMap);
